<template>
  <canvas ref="barCode" class="def-barcode"></canvas>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue';

const importBarcode = () => import(/* webpackChunkName: 'jsbarcode' */ 'jsbarcode');

const props = defineProps<{
  code: string;
  options?: { format?: string; width?: number; height?: number };
}>();

const barCode = ref<HTMLCanvasElement | null>(null);

onMounted(async () => {
  try {
    const barcode = await importBarcode();
    barcode.default(barCode.value, props.code, {
      format: 'code39',
      width: 1,
      height: 40,
      ...props?.options,
    });
  } catch (err) {
    console.error(err);
  }
});
</script>

<style lang="scss" scoped>
.def-barcode {
  //height: 50px;
}
</style>
